function home() {
    document.getElementById("game-sessions").classList.toggle("active");
}
function videogames() {
    document.getElementById("nintendo").classList.toggle("active");
    document.getElementById("playstation").classList.toggle("active");
    document.getElementById("xbox").classList.toggle("active"); 
}
function nintendo() {
    document.getElementById("nintendo-switch").classList.toggle("active");
    document.getElementById("nintendo-wii").classList.toggle("active");
}
function playstation() {
    document.getElementById("playstation-5").classList.toggle("active");
    document.getElementById("playstation-4").classList.toggle("active");
    document.getElementById("playstation-3").classList.toggle("active");
}
function xbox() {
    document.getElementById("xbox-series-x").classList.toggle("active");
    document.getElementById("xbox-one").classList.toggle("active");
    document.getElementById("xbox-360").classList.toggle("active");
}
function pc() {
    document.getElementById("pc-accessories").classList.toggle("active");
    document.getElementById("pc-components").classList.toggle("active");
    document.getElementById("pc-games").classList.toggle("active");
}
function boardgames() {}
function cardgames() {}
function more() {}